import * as React from 'react'
import {AkErrorIcon, AkWarningIcon, AkCheckCircleIcon} from '@fuegokit/fuegoicons-react'
import {AlertDialogProps, AlertDialogBodyProps, AlertDialogIconProps, AlertDialogFooterProps} from './types'

import Dialog from '../Dialog2'
import {Box} from '../..'

import {
  StyledDialogOverlay,
  StyledDialogBox,
  StyledAlertDialogHeader,
  StyledAlertDialogBody,
  StyledAlertDialogFooter
} from './styles'

export const AlertDialogBody = ({children}: AlertDialogBodyProps) => {
  return <StyledAlertDialogBody>{children}</StyledAlertDialogBody>
}

export const AlertDialogFooter = ({children}: AlertDialogFooterProps) => {
  return <StyledAlertDialogFooter>{children}</StyledAlertDialogFooter>
}

const iconMappings: Record<AlertDialogIconProps['appearance'], {icon: React.ReactNode; color: string}> = {
  danger: {icon: <AkErrorIcon />, color: 'icon.danger'},
  warning: {icon: <AkWarningIcon />, color: 'icon.warning.default'},
  success: {icon: <AkCheckCircleIcon />, color: 'icon.success'},
  default: {icon: null, color: ''}
}

const AlertDialogIcon = ({appearance}: AlertDialogIconProps) => {
  const {icon, color} = iconMappings[appearance]

  if (appearance === 'default') {
    return null
  }
  return <Box sx={{color}}>{icon}</Box>
}

const AlertDialog = ({children, ...props}: AlertDialogProps) => {
  const {size, appearance, heading, ...rest} = props

  return (
    <Dialog.Portal>
      <StyledDialogOverlay />
      <StyledDialogBox size={size || 'md'}>
        <StyledAlertDialogHeader>
          <AlertDialogIcon appearance={appearance} />
          {heading}
        </StyledAlertDialogHeader>
        {children}
      </StyledDialogBox>
    </Dialog.Portal>
  )
}

AlertDialog.defaultProps = {
  appearance: 'default',
  size: 'md'
}

export default AlertDialog
